import React from 'react';
import appStoreBadge from '../app_store.png';
import playStoreBadge from '../play_store.png';
import drumkneeIcon from '../drumknee.jpg';
import splitterooIcon from '../splitteroo.jpg';
import loopzIcon from '../loopz.jpg';
import dkBackingTracksIcon from '../dkbackingtracks.jpg';
import stompBoxIcon from '../stompbox.jpg';

function HomePage() {
  const apps = [
    {
      id: 1,
      name: 'DrumKnee 3D',
      description: 'A realistic 3D drum kit in your pocket. Play drums with touch controls and experience authentic drum sounds.',
      icon: drumkneeIcon,
      iosId: '1241682795',
      androidId: 'com.ribeirop.drumknee'
    },
    {
      id: 2,
      name: 'Splitteroo',
      description: 'Remove vocals from any song. Separate vocals and instrumentals with AI-powered technology for perfect karaoke or remixing.',
      icon: splitterooIcon,
      iosId: '6445834048',
      androidId: 'com.ribeirop.dksplitter'
    },
    {
      id: 5,
      name: 'Loopz - Beat maker',
      description: 'A powerful beat maker and music production tool. Create beats, loops, and original music compositions.',
      icon: loopzIcon,
      iosId: '1455583587',
      iosOnly: true
    },
    {
      id: 4,
      name: 'DK Backing Tracks',
      description: 'Browse and play backing tracks for musicians. Practice with professional quality backing tracks for any genre.',
      icon: dkBackingTracksIcon,
      iosId: '1512610287',
      iosOnly: true
    },
    {
      id: 3,
      name: 'Stomp Box Drums',
      description: 'Play realistic drum sounds with stomp box effects designed for guitarists. Create rhythm loops while playing guitar.',
      icon: stompBoxIcon,
      iosId: '1475051775',
      iosOnly: true
    }
  ];

  return (
    <div className="home-hero">
      <div className="header-section">
        <h1 className="header-title">music4fun</h1>
        <div className="header-separator"></div>
        <h2 className="header-subtitle">I make apps for fun, people happen to like them ;)</h2>
      </div>

      <div className="intro-section">
        <p>Hi! I'm Paulo, a solo developer creating all these apps from scratch. If you enjoy using them, please consider subscribing to the in-app purchases to support the development of new features and improvements. Your support truly makes a difference!</p>
      </div>

      <div className="download-section">
        <p>Click the links below to download the apps</p>
      </div>

      <div className="apps-showcase">
        {apps.map((app) => (
          <div key={app.id} className="app-card">
            <div className="app-header">
              <img src={app.icon} alt={app.name} className="app-icon" />
              <h3>{app.name}</h3>
            </div>
            
            <p className="app-description">{app.description}</p>
            
            <div className="app-store-links">
              {app.iosId && !app.androidOnly && (
                <a
                  href={`https://apps.apple.com/app/id${app.iosId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="store-link ios-link"
                  title="Download on the App Store"
                >
                  <img
                    src={appStoreBadge}
                    alt="Download on the App Store"
                    className="store-badge"
                  />
                </a>
              )}
              {app.androidId && !app.iosOnly && (
                <a
                  href={`https://play.google.com/store/apps/details?id=${app.androidId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="store-link android-link"
                  title="Get it on Google Play"
                >
                  <img
                    src={playStoreBadge}
                    alt="Get it on Google Play"
                    className="play-store-badge"
                  />
                </a>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="contact-section">
        <h3>Contact Us</h3>
        <p>5900 Balcones Drive STE 100<br />Austin, TX 78731</p>
        <a href="mailto:contact@music4fun.net" className="email-link">contact@music4fun.net</a>
      </div>
    </div>
  );
}

export default HomePage;
